import { useState } from "react";
import crowdPhoto from "../../assets/images/events/BannerHome.png";
import { siteTexts } from "../i18n/siteTexts";
import Button from "./Button";
import Header from "./Header";
import "./BackendUnavailablePage.css";

type BackendUnavailablePageProps = {
  onRetry?: () => Promise<void> | void;
};

export default function BackendUnavailablePage({
  onRetry,
}: BackendUnavailablePageProps) {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    if (!onRetry || retrying) return;
    setRetrying(true);
    try {
      await onRetry();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className="backend-unavailable-page">
      <Header />
      <main
        className="backend-unavailable-main"
        style={{ backgroundImage: `url(${crowdPhoto})` }}
      >
        <div className="backend-unavailable-overlay" aria-hidden="true" />

        <section
          className="backend-unavailable-content"
          role="status"
          aria-live="polite"
        >
          <div className="backend-unavailable-icon" aria-hidden="true">
            <span className="material-symbols-outlined">cloud_off</span>
          </div>

          <h1>{siteTexts.common.serverUnavailable.title}</h1>
          <p>{siteTexts.common.serverUnavailable.description}</p>

          <div className="backend-unavailable-actions">
            <Button
              type="button"
              onClick={handleRetry}
              disabled={retrying || !onRetry}
            >
              {retrying
                ? siteTexts.common.loading
                : siteTexts.common.serverUnavailable.actions.retry}
            </Button>
          </div>

          <p className="backend-unavailable-support-hint">
            {siteTexts.common.serverUnavailable.supportHint}
          </p>
        </section>
      </main>
    </div>
  );
}
